import { Injectable, EventEmitter } from '@angular/core';
    
@Injectable()
export class UserSettingsService {
    settings = {
        menuColumnToggle: true,
        notificationColumnToggle: true,
        slideColumnToggle: true,
        widgetColumnToggle: true,
        editArticleToggle: true,
        prePublishToggle: true,
        slidePreviewToggle: false,
        pageAdditionsToggle: true,
        articleDetailsToggle: true,
        articleNotesToggle: true,
        revisionNotesToggle: true
    };
    change = new EventEmitter();

    constructor() {
        this.loadSettings();
    }
    loadSettings() {
        try {
            let userSettings = JSON.parse(localStorage.getItem('userSettings'));
            for(var setting in userSettings ) {
                this.settings[setting] = userSettings[setting];
            }
        } catch(e) {
            console.log('Failed loading user settings.', e);
        }
    }
    toggle(setting) {
        const oldValue = JSON.stringify(this.settings);
        this.settings[setting] = !this.settings[setting];
        if( setting == 'slidePreviewToggle' && this.settings.slidePreviewToggle ) {
            this.settings.slideColumnToggle = true;
        }
        if( setting == 'slideColumnToggle' && !this.settings.slideColumnToggle ) {
            this.settings.slidePreviewToggle = false;
        }
        if( oldValue !== JSON.stringify(this.settings) ) {
            this.change.emit({
                oldValue: JSON.parse(oldValue),
                newValue: this.settings
            });
        }
        this.saveSettings();
    }
    saveSettings() {
        localStorage.userSettings = JSON.stringify(this.settings);
    }
}
